import {
  GET_TRANSCRIPTION_SUCCESS,
  GET_TRANSCRIPTION_FAILURE,
  GET_TRANSCRIPTION_REQUESTED,
  GET_CACHED_TRANSCRIPTION,
  EXPIRE_CACHED_TRANSCRIPTION,
} from './transcription.constants'
import { getCachedEntry, cacheEntry, removeCachedEntry, cacheInitialState } from './transcription.cache'

import { GET_CONTACT_REQUESTED } from '../MediaPlayer/mediaPlayer.constants'

const initialState = {
  loading: true,
  error: false,
  texts: [],
  cache: cacheInitialState,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_CACHED_TRANSCRIPTION: {
      const cachedEntry = getCachedEntry(state.cache, action.contactId)
      return {
        ...state,
        loading: false,
        error: false,
        texts: cachedEntry.texts.slice(),
      }
    }
    case EXPIRE_CACHED_TRANSCRIPTION: {
      return {
        ...state,
        cache: removeCachedEntry(state.cache, action.ccrid),
      }
    }
    case GET_CONTACT_REQUESTED: {
      return { ...initialState }
    }
    case GET_TRANSCRIPTION_REQUESTED: {
      return {
        ...state,
        loading: true,
        error: false,
        texts: [],
      }
    }
    case GET_TRANSCRIPTION_SUCCESS: {
      const { data } = action
      return {
        ...state,
        loading: false,
        error: false,
        texts: data.texts,
        cache: cacheEntry(state.cache, data),
      }
    }
    case GET_TRANSCRIPTION_FAILURE: {
      return {
        ...state,
        loading: false,
        error: true,
        texts: [],
      }
    }
    default: {
      return state
    }
  }
}
